// extracted by mini-css-extract-plugin
export default {"container":"l1774wfAFXyQnYk0qWAn","title":"GddK_fVhRtbXVU1OCUu8"};